<template>
  <div>
    <header class="relative">
      <div class="h-screen overflow-hidden relative">
        <Hero />
        <div class="absolute w-full top-1/2 flex flex-col items-center translate-y-[-50%]">
          <img class="w-[122px] md:w-[149px]" width="146" src="../assets/top/logo-w.svg" alt="">
          <div class="inline-block relative movie cursor-pointer mt-2" @click="open = true">
            <img class="w-[85px] md:w-[102px]" width="102" src="../assets/top/play-movie.svg" alt="">
            <img class="w-[30px] mx-auto mt-1 icon-play" src="../assets/common/play.svg" alt="">
          </div>
        </div>
        <transition name="fade">
          <div v-show="open" class="z-20 h-screen w-full fixed top-0 inset-0 flex items-center justify-center">
            <div @click="open = false" class="cursor-pointer bg-black opacity-75 w-full h-full absolute top-0"></div>
            <div class="close cursor-pointer" @click="open = false"></div>
            <transition name="fade-delay">
              <div v-if="open" class="wrap">
                <div style="padding:56.25% 0 0 0;position:relative;">
                  <iframe style="position:absolute;top:0;left:0;width:100%;height:100%;" width="560" height="315" src="https://www.youtube.com/embed/WtWvrf6WHs8?autoplay=1&controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </div>
              </div>
            </transition>
          </div>
        </transition>
        <FrontPageNews />
      </div>
    </header>

    <a class="flex items-center justify-center border-gray-200 border py-14 md:pt-6 md:pb-6 w-[80%] max-w-[876px] mx-auto mt-24 hover:border-gray-400 transition-colors" href="https://nagareru.acyuzuriha.com/" target="_blank">
      <img src="../assets/top/nagareru.png" alt="新拠点ながれる12月オープン予定" width="176" />
    </a>

    <div class="px-1/14 mt-[120px] p-top__intro">
      <section>
        <transition
            appear
            @enter="inView"
        >
        <div class="p-top__intro--imageWrap">
          <div class="p-top__intro--image01">
            <img src="../assets/top/image01.png" class="w-full object-cover aspect-square	md:aspect-auto" alt="" />
            <p class="p-top__intro__copy-1 text-white js-staggerText">
              <span class="indent">「</span><span>安</span><span>心</span><span>」</span><span class="indent">と</span><br />
              <span class="indent">「</span><span>楽</span><span>し</span><span>い</span><span>」</span><span class="indent">を</span><br />
              <span>い</span><span>っ</span><span>し</span><span>ょ</span><span>に</span></p>
          </div>
          <p class="p-top__intro__copy-1 p-top__intro__copy--black js-staggerText">
            <span class="indent">「</span><span>安</span><span>心</span><span>」</span><span class="indent">と</span><br />
            <span class="indent">「</span><span>楽</span><span>し</span><span>い</span><span>」</span><span class="indent">を</span><br />
            <span>い</span><span>っ</span><span>し</span><span>ょ</span><span>に</span></p>
        </div>
        </transition>

        <transition
            appear
            @enter="inView"
        >
          <div class="flex gap-x-1/14 mt-32 md:mt-48">
            <div class="p-top__intro--image02 w-1/2">
              <img src="../assets/top/image03.jpg" class="w-full" />
            </div>
            <div class="p-top__intro--image02 w-1/2">
              <img src="../assets/top/image02.jpg" class="w-full" />
            </div>
          </div>
        </transition>
        <p class="p-top__intro__copy-2">
          <transition
              appear
              @enter="staggerText"
          >
            <span v-html="spanWrapText(`生きてきてくれてありがとう`)"></span>
          </transition>
          <transition
              appear
              @enter="fadeInUp"
          >
          <span class="p-top__intro__copy-2--en" v-html="spanWrapText(`Thank you for coming alive`)"></span>
          </transition>
        </p>
      </section>

      <div class="p-top__menu">
        <h2>content</h2>
        <transition
            appear
            @enter="fadeInUp"
        >
        <ul>
          <li>
            <a href="/about" class="flex justify-center bg-black text-white items-center">
              <div class="p-top__menu--inner">
                <div class="p-top__menu__title">
                  <span class="p-top__menu__title__sub">About us</span>
                  <span class="p-top__menu__title__main">ゆずりはについて</span>
                </div>
                <p class="p-top__menu__text">
                  <span>大切にしていること、メンバーの事</span>
                </p>
              </div>
            </a>
          </li>
          <li>
            <a href="/action" class="flex justify-center bg-black text-white items-center">
              <div class="p-top__menu--inner">
                <div class="p-top__menu__title">
                  <span class="p-top__menu__title__sub">Action</span>
                  <span class="p-top__menu__title__main">活動紹介</span>
                </div>
                <p class="p-top__menu__text">
                  <span>個別相談、ゆずりはサロン、わたしたちにできること</span>
                </p>
              </div>
            </a>
          </li>
          <li>
            <a href="/news"  class="flex justify-center bg-black text-white items-center">
              <div class="md:flex items-end p-top__menu--inner">
                <div class="p-top__menu__title">
                  <span class="p-top__menu__title__sub">News</span>
                  <span class="p-top__menu__title__main">お知らせ</span>
                </div>
                <p class="p-top__menu__text">
                  <span>イベントや講演など活動に関するお知らせ</span>
                </p>
              </div>
            </a>
          </li>
          <li>
            <a href="/donation" class="flex justify-center bg-black text-white items-center">
              <div class="md:flex items-end p-top__menu--inner">
                <div class="p-top__menu__title">
                  <span class="p-top__menu__title__sub">Donation</span>
                  <span class="p-top__menu__title__main">寄付・参加</span>
                </div>
                <p class="p-top__menu__text">
                  <span>ご寄付、チャリ本、欲しい物リスト、ボランティアなど</span>
                </p>
              </div>
            </a>
          </li>
        </ul>
        </transition>
      </div>

    <section class="p-top__overview">
      <div class="mx-auto">
        <div style="padding:56.25% 0 0 0;position:relative;">
          <iframe style="position:absolute;top:0;left:0;width:100%;height:100%;" width="560" height="315" src="https://www.youtube.com/embed/WtWvrf6WHs8?autoplay=1&controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
        <h3 class="c-title--hasLine text-center mt-15 font-medium">
          ゆずりはの由来
        </h3>
        <p class="text-[11.5px] md:text-lg mt-8 text-center leading-[2.2] text-center">
          新しい季節に若葉が生えるとき、古い葉は若葉に光や栄養が行き渡るよう落葉する。<br />
          ゆずりはの木のように、かさなり、ゆずることが自然になされる願いをこめて名付けました。
        </p>
      </div>
    </section>

    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Hero from "../components/Hero";
import FrontPageNews from "../components/FrontPageNews";
import Modal from "../components/Modal";
gsap.registerPlugin(ScrollTrigger);

export default {
  name: 'Home',
  components: {
    Hero,
    FrontPageNews,
    Modal,
  },
  data() {
    return {
      open: false
    }
  },
  methods:{
    inView(elem) {
      gsap.to(elem, {
        scrollTrigger: {
          trigger: elem,
          start: "top 55%",
        },
        onStart:() => {
          elem.classList.add('in-view')
        },
        onComplete: () => {
          const targets = elem.querySelectorAll('.js-staggerText')
          if (targets) {
            for (const item of targets) {
              gsap.to(item.querySelectorAll('span'), {
                stagger: 0.07,
                duration: 0.5,
                ease: "power2.out",
                opacity: 1,
              });
            }
          }
        }
      });
    },
    fadeInUpGroup(elem) {
      gsap.to(elem.childNodes, {
        scrollTrigger: {
          trigger: elem,
          start: "top 70%",
        },
        stagger: 0.3,
        y: 0,
        duration: 1,
        ease: "power2.out",
        opacity: 1,
      });
    },
    fadeLeftRight(elem) {
      gsap.to(elem.lastChild, {
        scrollTrigger: {
          trigger: elem,
          start: "top 70%",
        },
        stagger: 0.3,
        duration: 1,
        ease: "power2.out",
        scaleX: 0
      });
    },
    fadeRightLeft(elem) {
      gsap.to(elem.lastChild, {
        scrollTrigger: {
          trigger: elem,
          start: "top 60%",
        },
        stagger: 0.3,
        duration: 1,
        ease: "power2.out",
        scaleX: 0
      });
    },
    fadeLeftRightGroup(elem) {
      const target = [...elem.childNodes].map((obj) => obj.lastChild)
      gsap.to(target, {
        scrollTrigger: {
          trigger: elem,
          start: "top 70%",
        },
        stagger: 0.3,
        duration: 1,
        ease: "power2.out",
        scaleX: 0
      });
    },
    fadeRightLeftGroup(elem) {
      const target = [...elem.childNodes].map((obj) => obj.lastChild)
      gsap.to(target, {
        scrollTrigger: {
          trigger: elem,
          start: "top 60%",
        },
        stagger: 0.3,
        duration: 1,
        ease: "power2.out",
        scaleX: 0
      });
    },
  }
}
</script>

<style lang="scss" scoped>

.js-copyScrollArea {
  height: 1185px;
  width: 100%;
  position: absolute;
  top: calc(100vh - 530px);
  left: 0;
  right: 0;
  margin: auto;
  overflow: hidden;
  @apply hidden md:flex justify-end;
}

.p-top__images--01 {
  width: 1221px;
  display: flex;
  position: relative;
  left: 50%;
  transform: translateX(-54%);
  align-items: flex-end;
}

.p-top__images--02 {
  width: 1221px;
  display: flex;
  position: relative;
  left: 50%;
  transform: translateX(-46%);
  align-items: flex-start;
  flex-direction: row-reverse;
}

.p-top__images--03 {
  @apply flex justify-end relative w-[551px] md:w-[1371px] left-1/2 translate-x-[-50%];
}

.p-top__images--04 {
  display: flex;
  position: relative;
  align-items: flex-start;
  @apply left-1/2 w-[551px] md:w-[1371px] translate-x-[-50%] ;
}


.main-width {
  max-width: 816px;
  margin: 0 auto;
}

.main-width--wide {
  max-width: 1050px;
  margin: 0 auto;
}

.p-top__intro {

  &__copy-1 {
    font-family: 'Noto Sans JP', sans-serif;
    @apply text-[2.6rem] md:text-[3.6875rem];
    line-height: 1.58;
    letter-spacing: 0.3em;
    transition: opacity 2s cubic-bezier(0,.7,.3,1) 1s;

    span {
      opacity: 0;
    }
    .indent {
      @apply ml-[-0.5em]
    }
  }

  .p-top__intro--image01 {
    position: relative;
    z-index: 2;
    opacity: 0;
    transition: all 2s cubic-bezier(0,.7,.3,1);
    background: #F8F6EF;
    @apply overflow-hidden;

    img {
      opacity: 0;
      transform: scale(1.1);
      transition: all 2s cubic-bezier(0,.7,.3,1) 0.2s;
    }
  }

  .p-top__intro--image02 {
    transform: translateY(8rem);
    opacity: 0;
    transition: all 2s cubic-bezier(0,.7,.3,1);
    background: #F8F6EF;
    @apply overflow-hidden;

    img {
      opacity: 0;
      transform: scale(1.1);
      transition: all 2s cubic-bezier(0,.7,.3,1) 0.2s;
    }
  }

  .p-top__intro__copy--black {
    z-index: 1;
  }

  &__copy-2 {
    @apply text-35 mt-10;
    line-height: 1.5;
    letter-spacing: 0.3em;

    &--en {
      @apply text-base block mt-7;
      line-height: 1;
      letter-spacing: 0.15em;
    }
  }

  &--imageWrap {
    position: relative;

    .p-top__intro__copy-1 {
      position: absolute;
      @apply top-[60%] md:top-[50%];
      left: 3%;
    }
  }
}
.p-top__intro--imageWrap {
  transform: translateY(8rem);
  transition: all 2s cubic-bezier(0,.7,.3,1);
}
.p-top__intro--imageWrap.in-view {
  transform: translateY(0);
}

.in-view .p-top__intro--image01,
.in-view .p-top__intro--image02 {
  opacity: 1;
  transform: translateY(0);

  img {
    opacity: 1;
    transform: scale(1);
  }
}

// top__menu

.p-top__menu {
  margin: 0 auto;
  @apply mt-36 md:mt-36;
}

.p-top__menu h2 {
  @apply text-sm font-bold mb-3 tracking-[0.15em];
}

.p-top__menu li{
  margin-top: 1px;
  width: 100%;
  overflow: hidden;
  @apply h-[183px] md:h-auto;

  @media screen and (min-width: 640px) {
    aspect-ratio: 1 / 0.277;
  }
}

.p-top__menu li a {
  height: 100%;
  background-size: 100%;
  background-position: center center;
  transition: all .5s;
}
.p-top__menu li:nth-child(1) a {
  background-image: url("../assets/top/menu-image01.jpg");
 @media screen and (max-width: 640px) {
   background-image: url("../assets/top/menu-image01-sp.jpg");
   background-size: 105%;
 }
}
.p-top__menu li:nth-child(2) a {
  background-image: url("../assets/top/menu-image02.jpg");
  @media screen and (max-width: 640px) {
    background-image: url("../assets/top/menu-image02-sp.jpg");
    background-size: 105%;
  }
}
.p-top__menu li:nth-child(3) a {
  background-image: url("../assets/top/menu-image03.jpg");
  @media screen and (max-width: 640px) {
    background-image: url("../assets/top/menu-image03-sp.jpg");
    background-size: 105%;
  }
}
.p-top__menu li:nth-child(4) a {
  background-image: url("../assets/top/menu-image04.jpg");
  @media screen and (max-width: 640px) {
    background-image: url("../assets/top/menu-image04-sp.jpg");
    background-size: 105%;
  }
}

.p-top__menu li a:hover {
  background-size: 106%;
}

.p-top__menu--inner {
  @apply md:flex items-end md:pl-8 md:pl-0 w-10/12;
}

.p-top__menu__title {
  @apply md:w-5/12 flex-1;
}
.p-top__menu__title__main {
  @apply text-22 md:text-27 md:mt-4 block leading-none tracking-widest my-2 md:my-0;
}

.p-top__menu__title__sub {
 @apply text-xxs block tracking-widest;
}

.p-top__menu__text {
  @apply text-13 tracking-widest md:w-7/12;


  span {
    @apply relative overflow-hidden inline-block md:py-0 md:px-4;

    &:before {
      position: absolute;
      content: '';
      display: block;
      top: 0;
      bottom: 0;
      right: 100%;
      margin: auto;
      width: 4px;
      height: 4px;
      border: 4px solid transparent;
      border-left: 4px solid #fff;
    }
    &:after {
      width: 100%;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      margin: auto;
      content: '';
      display: block;
      height: 1px;
      background: #fff;
      transform:scaleX(0);
      transform-origin: left center;
      animation-name:effect_animation;
      animation-duration: 0.3s;
    }
  }
}

.p-top__menu li a:hover .p-top__menu__text span:before {
  right: -4px;
  transition:right 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  animation: none;
}
.p-top__menu li a:hover .p-top__menu__text span:after {
  transform:scaleX(1);
  transition:transform 0.4s cubic-bezier(0.23, 1, 0.32, 1);
  animation:none;
}

@keyframes effect_animation {
  0% {
    transform: scaleX(1);
  }
  100% {
    transform: scaleX(1) translateX(100%);
  }
}


//overview

.p-top__overview {
  @apply mt-28 md:mt-39 mb-24 md:mb-40 font-light;
}

.p-top__overview__title {
  letter-spacing: 5px;
  @apply text-center;
}
.p-top__overview__title span:first-child{
  display: block;
  letter-spacing: 2px;
}

.p-top__overview__title span:last-child {
  display: flex;
  align-items: center;
  text-indent: -3px;
}

.p-top__overview__title span:last-child:after {
  content: '';
  display: block;
  width: 10%;
  height: 1px;
  background: #000;
  flex-grow: 1;
  @apply ml-[10px] md:ml-[20px];
}

.copy--01 {
  letter-spacing: 0.6em;
  line-height: 2.5;
  @apply text-[15px];

  span {
    text-indent: 10.6em;
    display: inline-block;
  }
}

.icon-play {
  animation: flash 1.5s linear infinite;
}
@keyframes flash {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}


.wrap {
  width: 90%;
  max-width: 1280px;
}

.close {
  @apply fixed top-8 right-8 w-6 h-6 md:w-8 md:h-8 z-20;
  background: url("../assets/common/close-w.svg") no-repeat center center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-delay-enter-active,
.fade-delay-leave-active {
  transition: opacity 0.5s ease 0.3s, transform 0.5s ease 0.3s;
}

.fade-delay-enter-from,
.fade-delay-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

</style>